import React from "react";
import { SEO } from "@/components/SEO";
import { privacyPolicyHtml } from "@/content/privacyPolicyContent";
import { SITE_NAME, SITE_URL } from "@/content/siteConfig";

export default function PrivacyPolicy() {
  return (
    <>
      <SEO
        title={`Privacy Policy - ${SITE_NAME}`}
        description="The exact CrenelView Privacy Policy: what the app collects (nothing), what stays on your phone, and how the accessibility permission works."
        path="/privacy-policy"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: `Privacy Policy - ${SITE_NAME}`,
          url: `${SITE_URL}/privacy-policy`,
        }}
      />

      <section className="mx-auto max-w-3xl px-6 pt-14 pb-20 sm:pt-20 sm:pb-28">
        <div
          className="policy-content"
          data-testid="privacy-policy-body"
          dangerouslySetInnerHTML={{ __html: privacyPolicyHtml }}
        />
      </section>
    </>
  );
}
